export default __webpack_public_path__ + "static/media/alexandre-lourenco.ddd892a3.webp";